import { useRegisterUserAction } from './useRegisterUserAction';

import { drawingTool } from '~/core/engine/DrawingTool';
import { UserDesignOperation } from '~/core/enums';
import {
  boundingBoxAsPointArray,
  findBoundingBox,
  updateShapeByTranslation,
} from '~/core/helpers';
import { PredefinedShape } from '~/core/models';
import { useDrawingShapeContext } from '~/legacy/easy-estimator-page/context';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { updateNeedRedrawCanvas } from '~/redux/slices/drawingShape';
import { selectFabricCanvas } from '~/redux/slices/fabric';

export const useAddPredefinedShape = () => {
  const dispatch = useAppDispatch();
  const canvas = useAppSelector(selectFabricCanvas);

  const { registerUserAction } = useRegisterUserAction();

  const {
    getters: { drawingShapes },
    handlers: {
      autoPlaceShapeTranslation,
      updateDrawingShapes,
      updateActiveDrawingShapeId,
    },
  } = useDrawingShapeContext();

  const addPredefinedShape = (selectedPredefinedShape: PredefinedShape) => {
    if (!canvas || !selectedPredefinedShape) {
      return;
    }

    const dShapes = drawingTool.buildShapeFromPredefinedShape(
      selectedPredefinedShape
    );

    // if there isn't any shape selected or the case when it was previously selected a shape or free drawn
    if (drawingShapes.length > 0) {
      const newPoly =
        dShapes.length === 1
          ? dShapes[0].highlightPoints || []
          : boundingBoxAsPointArray(
              findBoundingBox(
                dShapes.map((shape) => shape.highlightPoints || []).flat(1)
              )
            );
      const destVector = autoPlaceShapeTranslation(newPoly);

      dShapes.forEach((shape) => updateShapeByTranslation(destVector, shape));

      updateActiveDrawingShapeId(dShapes[0].id);
    }

    updateDrawingShapes([...drawingShapes, ...dShapes]);
    dispatch(updateNeedRedrawCanvas(true));
    registerUserAction(UserDesignOperation.DRAW_SHAPE);
  };

  return { addPredefinedShape };
};
